import React from 'react'
import { motion } from 'framer-motion'

import { AppWrap, MotionWrap } from '../../wrapper'

import { images } from '../../constants'
import './Header.scss'

const scaleVariants = {
  whileInView:{
    scale: [0, 1],
    opacity: [0,1],
    transition: {
      duration: 1,
      ease: 'easeInOut'
    }
  }
}

const Header = () => {
  return (
    <div className='app__header app__flex'>
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className='app__header-info'
      >
        <div className='app__header-badge'>
          <div className='badge-cmp app__flex'>
            <span>👋</span>
            <div style={{  marginLeft: 20 }}>
              <p className="p-text">Hello, I am</p>
              <h1>Rudy Paolo</h1>
            </div>
          </div>

{/*           <div className="tag-cmp app__flex">
            <p className="p-text">Systems Engineer</p>
            <p className="p-text">Specializing in Big Data Management</p>
            <p className="p-text">Techonologies and Analytics</p>
          </div> */}

{/*           <div className="tag-cmp app__flex">
            <p className="p-text">My top skills are</p>
            <p className="p-text">SQL, Excel, Looker, Tableau</p>
            <p className="p-text">And Front-end with MERN stack</p>
          </div>
 */}

        </div>
      </motion.div>

      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='app__header-img'
      >
        <img src={images.profile} alt="profile_bg" />

        <motion.img
          whileInView={{ scale: [0, 1] }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
          src={images.circle}
          alt="profile_circle"
          className="overlay_circle"
        />

      </motion.div>


      <motion.div
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className='app__header-circles'
      >
        {[images.sql, images.nosql, images.python].map((circle, index) => (
          <div className="circle-cmp app__flex" key={`circle-${index}`}>
            <img src={circle} alt="circle" />
          </div>
        ))}
      </motion.div>

    </div>
  )
}


export default AppWrap(
  MotionWrap(Header, 'app__home'),
  'home',
  'app__primarybg'
)